import { Button } from "@/components/ui/button";

const programs = [
  {
    badge: "Start Here",
    name: "Portfolio Kickstart",
    duration: "Self-paced · 1-on-1",
    description:
      "Brand new to investing? We build your first real portfolio together — broker setup, allocation, what to actually buy, and why your money will never sit idle again.",
    perks: [
      "Personal portfolio plan",
      "Broker & account walkthrough",
      "Starter watchlist",
      "Risk & allocation framework",
    ],
    accent: "amber",
  },
  {
    badge: "Most Popular",
    name: "Stock Picks Mentorship",
    duration: "Ongoing · 1-on-1 with Leo",
    description:
      "My current portfolio, my actual picks, and the research behind each one. Weekly calls, real-time alerts when I buy or sell, and a private chat for questions.",
    perks: [
      "Weekly 1:1 strategy calls",
      "Live buy / sell alerts",
      "Deep-dive research notes",
      "Private chat access",
    ],
    accent: "gold",
    featured: true,
  },
  {
    badge: "Wealth Track",
    name: "Long-Term Wealth Plan",
    duration: "12-week build · Personal coaching",
    description:
      "For people who want to design a serious long-term plan — compounding strategy, dividend reinvestment, smart money positioning, and a portfolio built to outlast the noise.",
    perks: [
      "Custom long-term roadmap",
      "Compounding & DRIP setup",
      "Tax-aware structuring guidance",
      "Quarterly portfolio reviews",
    ],
    accent: "emerald",
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-32 lg:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-20">
          <div>
            <p className="text-xs uppercase tracking-[0.35em] text-amber-500 mb-6">
              — Ways To Work With Me
            </p>
            <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-white tracking-tight max-w-3xl">
              Three paths. <em className="italic text-amber-400">One goal —</em> your money working for you.
            </h2>
          </div>
          <p className="text-zinc-400 text-lg max-w-md">
            Pricing varies by what you actually need. No copy-paste packages —
            reach out and we'll figure out the right fit together.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-6">
          {programs.map((p) => (
            <div
              key={p.name}
              data-testid={`program-card-${p.name.replace(/\s/g, "-").toLowerCase()}`}
              className={`relative group rounded-3xl p-8 lg:p-10 border transition-all duration-500 hover:-translate-y-2 flex flex-col ${
                p.featured
                  ? "bg-gradient-to-b from-amber-900/20 to-[#0A0A0A] border-amber-600/40 lg:scale-[1.02]"
                  : "bg-[#0A0A0A] border-white/10 hover:border-white/20"
              }`}
            >
              <div className="flex items-center justify-between mb-10">
                <span
                  className={`text-[10px] uppercase tracking-[0.3em] px-3 py-1.5 rounded-full ${
                    p.featured
                      ? "bg-amber-500/20 text-amber-300 border border-amber-500/40"
                      : "bg-white/5 text-zinc-400 border border-white/10"
                  }`}
                >
                  {p.badge}
                </span>
                <span className="text-xs text-zinc-500">{p.duration}</span>
              </div>

              <h3 className="font-serif-display text-3xl text-white leading-tight">
                {p.name}
              </h3>

              <div className="mt-3 mb-8 flex items-baseline gap-2">
                <span className="font-serif-display text-2xl text-amber-400">
                  Contact for pricing
                </span>
              </div>

              <p className="text-zinc-400 leading-relaxed mb-8">
                {p.description}
              </p>

              <ul className="space-y-3 mb-10 flex-1">
                {p.perks.map((perk) => (
                  <li
                    key={perk}
                    className="flex items-start gap-3 text-zinc-300"
                  >
                    <span className="mt-1.5 h-1.5 w-1.5 rounded-full bg-amber-500 shrink-0" />
                    <span className="text-sm">{perk}</span>
                  </li>
                ))}
              </ul>

              <Button
                asChild
                data-testid={`program-cta-${p.name.replace(/\s/g, "-").toLowerCase()}`}
                className={`w-full rounded-full py-6 ${
                  p.featured
                    ? "bg-amber-500 hover:bg-amber-400 text-black"
                    : "bg-white/5 hover:bg-white/10 text-white border border-white/20"
                }`}
              >
                <a href="#book">Reach Out →</a>
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
